module.exports = __webpack_public_path__ + "img/9791195371815.143318d0.jpg";